/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';

import { params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel';
import DimensionValue from '../../DimensionValue';

const GableLeftLeanToMeasurement = ({ color }) => {
    const [arrowPositions, setArrowPositions] = useState({
        widthArrowSize: 0,
        widthArrowPos: [0, 0, 0],
        lengthArrowSize: 0,
        leftLengthArrowPos: [0, 0, 0],
        rightLengthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const {
            p_w, lean_p_w, lean_p_d, lean_p_h
        } = params;
        const alignPosOffset = 0;
        let newArrowPositions  = {
            widthArrowSize: lean_p_w /* + 0.6 */,//->SE3-I6164 ->Dimension isn't coming correct for secondary building//
            widthArrowPos: [-p_w / 2 - lean_p_d - offset, arrowOffset - 0.1, alignPosOffset],
            lengthArrowSize: lean_p_d,
            leftLengthArrowPos: [-p_w / 2 - lean_p_d / 2 - offset, 0, -lean_p_w / 2 - arrowOffset + alignPosOffset],
            rightLengthArrowPos: [-p_w / 2 - lean_p_d / 2 - offset, 0, lean_p_w / 2 + arrowOffset + alignPosOffset],
            heightArrowSize: lean_p_h,
            leftHeightArrowPos: [-p_w / 2 - lean_p_d - offset, 0, lean_p_w / 2 + arrowOffset + alignPosOffset],
            rightHeightArrowPos: [-p_w / 2 - lean_p_d - offset, 0, -lean_p_w / 2 - arrowOffset + alignPosOffset],
        };
        setArrowPositions(newArrowPositions);
    }, [
        params.p_w, params.lean_p_w, params.lean_p_d, params.lean_p_h
    ]);

    const {
        widthArrowSize, widthArrowPos, lengthArrowSize,
        leftLengthArrowPos, rightLengthArrowPos, heightArrowSize,
        leftHeightArrowPos, rightHeightArrowPos
    } = arrowPositions;



    return params.add_left_lean && (
        <group name='Measurements-gableLeftLeanto'>
            {/****** Width ******/}
            <group name='front-arrow' position={widthArrowPos} rotation={[0, Math.PI / 2, 0]}>
                <LineModel length={widthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, -0.2, -0.5]} rotation={[0, Math.PI, 0]} value={`${convertFeet(widthArrowSize,false)} W`} slopeAngle={25} type={'lean'} cmpPos={widthArrowPos} />
            </group>

            {/****** Length ******/}
            <group name='left-arrow' position={leftLengthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} L`} slopeAngle={25} type={'lean'} cmpPos={leftLengthArrowPos} />
            </group>
            <group name='right-arrow' position={rightLengthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} L`} slopeAngle={25} type={'lean'} cmpPos={rightLengthArrowPos} />
            </group>

            {/****** height ******/}
            <group name='right-arrow' position={leftHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.lean_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.lean_p_h / 2, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
            </group>
            <group name='left-arrow' position={rightHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.lean_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.lean_p_h / 2, offset]} rotation={[0, Math.PI, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos} />
            </group>
        </group>
    );
};

export default GableLeftLeanToMeasurement;
